import { defineComponent as _defineComponent } from 'vue'

import { ArticleV1, NewArticleV1 } from '@ilteducation/content-registry-types';

type Props = {
  id?: string;
  title: string;
  item?: ArticleV1;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Create',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string;
  title: string;
  item?: ArticleV1;
}


const now = new Date();
const month = now.getMonth() + 1 < 10 ? `0${now.getMonth() + 1}` : `${now.getMonth() + 1}`;
const day = now.getDate() < 10 ? `0${now.getDate()}` : `${now.getDate()}`;

const newArticle: NewArticleV1 = {
  type: 'ArticleV1',
  headline: '',
  description: '',
  isPublished: false,
  publicationTimestamp: `${now.getFullYear()}-${month}-${day}`,
};
let cloned: NewArticleV1 | undefined;
if (props?.item) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { id, ...rest } = props.item;
  cloned = rest;
}
const defaultArticle = cloned ?? newArticle;
const isClone = !!cloned;

return { __sfc: true,props, now, month, day, newArticle, cloned, defaultArticle, isClone }
}

})